/* src/app/cardholder/cardholder-open-loop-history/cardholder-open-loop-history.component.css */
.fa {
  font-size: 9pt;
}
/*# sourceMappingURL=cardholder-open-loop-history.component.css.map */
